<script lang="ts">
    import Checkbox from "../../widgets/Checkbox.svelte"
    import Select from "svelte-select"
    import { createEventDispatcher } from "svelte"
    import { _ } from "svelte-i18n"

    export let cartDontShipBefore: Date
    let dontShipBefore: boolean = !!cartDontShipBefore
    if (cartDontShipBefore) {
        cartDontShipBefore = new Date(cartDontShipBefore)
    }

    let dispatch = createEventDispatcher()

    const toggleDontShipBefore = (checked: boolean) => {
        dontShipBefore = checked
        if (!dontShipBefore) {
            resetDontShipCartBefore()
            dispatch("update", { cartDontShipBefore })
        }
    }

    const resetDontShipCartBefore = () => {
        cartDontShipBefore = null
        selectedMonday = null
    }

    let upcomingMondays: Date[] = []
    const today = new Date()

    for (let i = 0; i < 12; i++) {
        let nextMonday = new Date(today.getTime() + (i * 7 + ((7 - today.getDay() + 1) % 7)) * 24 * 60 * 60 * 1000)
        upcomingMondays.push(nextMonday)
    }

    let selectedMonday: { value: string; label: string } | null = null

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-KW${getWeekNumber(date)}`
    }

    const getWeekNumber = (d: Date) => {
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
        const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
        const weekNo = Math.ceil(((+d - +yearStart) / 86400000 + 1) / 7)
        return weekNo
    }

    $: if (selectedMonday) {
        cartDontShipBefore = new Date(selectedMonday.value)
    }

    if (!cartDontShipBefore) {
        resetDontShipCartBefore()
    } else {
        dontShipBefore = true
    }

    $: if (cartDontShipBefore) {
        dontShipBefore = true
    }
    $: if (!cartDontShipBefore) {
        resetDontShipCartBefore()
    }

    $: if ((upcomingMondays.length = 12)) {
        setSelectedMondayBasedOnCartDontShipBefore()
    }

    function dateEquals(date1: Date, date2: Date) {
        return (
            date1.getUTCFullYear() == date2.getUTCFullYear() &&
            date1.getUTCMonth() == date2.getUTCMonth() &&
            date1.getUTCDate() == date2.getUTCDate()
        )
    }

    function setSelectedMondayBasedOnCartDontShipBefore() {
        if (cartDontShipBefore) {
            const initialSelectedMonday = upcomingMondays.find((m) => {
                return dateEquals(m, cartDontShipBefore)
            })

            if (initialSelectedMonday) {
                selectedMonday = {
                    value: initialSelectedMonday.toISOString(),
                    label: formatDate(initialSelectedMonday),
                }
            }
        }
    }
</script>

<div class="cart-avis-form mt-md" class:invalid="{dontShipBefore && !cartDontShipBefore}">
    <div class="row">
        <div class="col-md-4">
            <Checkbox
                label="{$_('cart.shipment.dontShipBefore')}"
                on:checked="{() => toggleDontShipBefore(true)}"
                on:unchecked="{() => toggleDontShipBefore(false)}"
                checked="{dontShipBefore}"
            />
        </div>
        <div
            class:invalid="{dontShipBefore && !cartDontShipBefore}"
            class="col-md-2"
            style="display: flex;flex-direction: row; justify-content: flex-start;"
        >
            <Select
                bind:value="{selectedMonday}"
                clearable="{true}"
                disabled="{!dontShipBefore}"
                placeholder="{$_('cart.shipment.selectCalendarWeek')}"
                on:change="{() => dispatch('update', { cartDontShipBefore })}"
                on:clear="{() => {
                    toggleDontShipBefore(false)
                }}"
                items="{upcomingMondays.map((m) => {
                    return {
                        value: m.toISOString(),
                        label: formatDate(m),
                    }
                })}"
            />
        </div>
    </div>
</div>
